<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form">
        <template slot="tableSearch">

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097'"
            label="代理"
          >
            <el-select
              v-model="form.agentId"
              placeholder="请选择代理"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in agentList"
                :key="item.agentId"
                :label="item.agentId + '-' + item.agentName"
                :value="item.agentId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097'"
            label="商务"
          >
            <el-select
              v-model="form.bizPersonnelId"
              placeholder="请选择商务"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in selectBizPersonnel"
                :key="item.bizPersonnelId"
                :label="item.bizPersonnelId + '-' + item.bizPersonnelName"
                :value="item.bizPersonnelId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="AppID">
            <el-input v-model="form.appId" placeholder="请输入AppID"></el-input>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input
              v-model="form.merchantName"
              placeholder="商户名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="查看待结算">
            <el-select
              v-model="form.showWaitSettleAmount"
              style="width: 60px"
              placeholder="否"
            >
              <el-option label="否" value="00"></el-option>
              <el-option label="是" value="01"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small"
            >添加商户</el-button
          >
        </template>

        <template
          slot="buttonArea"
          v-if="$store.state.roleId == '1070960390067716097'"
        >
          <el-button
            type="primary"
            @click="addBizPersonnel"
            size="small"
            >添加商务</el-button
          >
        </template>

        <template slot="tableColumn">
          <!-- <el-table-column
            prop="agentId"
            width="120px"
            label="agentId"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="agentName"
            width="150px"
            label="代理名称"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="appId"
            width="120px"
            label="AppId"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="depositStatus"
            width="80px"
            :formatter="$formatter.formatMerPayTypeStatus"
            label="收付状态"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="prodStatus"
            width="100px"
            :formatter="$formatter.formatProdStatus"
            label="对接状态"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="120px"
            prop="loginName"
            label="商户名称"
            align="center"
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="balance"
            width="120px"
            :formatter="$formatter.FenToYuan"
            label="余额"
          >
          </el-table-column>

          <el-table-column
            prop="freezeBalance"
            width="160px"
            :formatter="$formatter.FenToYuan"
            label="冻结金额"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="waitSettleAmount"
            width="120px"
            label="待结算"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.waitSettleAmount">
                {{
                  $formatter.FenToYuan(null, null, row.waitSettleAmount, null)
                }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>


          <el-table-column
            prop="rcsIp"
            width="340px"
            label="IP白名单"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="80px"
            prop="payinRate"
            label="代收费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="80px"
            prop="payinFee"
            label="代收单笔"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="80px"
            prop="payoutRate"
            label="代付费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="80px"
            prop="payoutFee"
            label="代付单笔"
            align="center"
          >
          </el-table-column>



          <el-table-column
            width="80px"
            prop="bizPersonnelId"
            label="所属商务"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="80px"
            prop="addPersonnelId"
            label="添加人员"
            align="center"
          >
          </el-table-column>

          <el-table-column
            width="270px"
            prop="signKey"
            label="SKMD5"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="createTime"
            width="160"
            label="创建时间"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.createDate">
                {{
                  $formatter.formatDate(
                    null,
                    null,
                    row.createDate + row.createTime,
                    null
                  )
                }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="mini"
                @click="edit(scope.row)"
                >编辑
              </el-button>
              <el-button
                type="primary"
                plain
                size="mini"
                v-if="$store.state.roleId == '1070960390067716097'"
                @click="unbindTg(scope.row)"
                >解绑TG群
              </el-button>
              <el-button
                type="primary"
                plain
                size="mini"
                v-if="$store.state.roleId == '1070960390067716097'"
                @click="unbindGoogle(scope.row)"
                >重置谷歌验证
              </el-button>
              <el-button
                type="primary"
                plain
                size="mini"
                v-if="$store.state.roleId == '1070960390067716097'"
                @click="resetMerPass(scope.row)"
                >重置密码
              </el-button>
              <el-button
                type="primary"
                plain
                size="mini"
                v-if="$store.state.roleId == '1070960390067716097'"
                @click="addMerStaffUser(scope.row)"
                >添加员工号
              </el-button>
              
              <!-- <el-button
                type="primary"
                plain
                size="mini"
                v-if="$store.state.roleId == '1070960390067716097'"
                @click="editTieredBilling(scope.row)"
                >阶梯计费
              </el-button> -->
            </template>
          </el-table-column>
        </template>
      </page>

      <MerchantEdit
        :show.sync="showDialog"
        :formData="formData"
        :action="action"
      ></MerchantEdit>

      <TieredBilling
        :show.sync="isTieredBillingDialog"
        :formData="formData"
        :action="action"
      ></TieredBilling>

      <AddBizPersonnel
        :show.sync="isAddBizPersonnelDialog"
      ></AddBizPersonnel>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import MerchantEdit from './MerchantEdit'
import TieredBilling from './TieredBilling'
import AddBizPersonnel from './AddBizPersonnel'


export default {
  name: 'Systems',
  components: {
    page: Page,
    MerchantEdit: MerchantEdit,
    TieredBilling: TieredBilling,
    AddBizPersonnel: AddBizPersonnel,
  },

  data() {
    return {
      url: '/merchant/selectList',
      action: '',
      agentList: [],
      selectBizPersonnel: [],
      form: {
        bizPersonnelId: '',
        agentId: '',
        showWaitSettleAmount: '00',
      },
      showDialog: false,
      formData: null,
      TieredBillingData: null,
      showSetPayDialog: false,
      appId: '',
      showWalletInfoDialog: false,
      isTieredBillingDialog: false,
      isAddBizPersonnelDialog: false,
    }
  },
  methods: {
    add() {
      this.action = 'addMerchant'
      this.formData = null
      this.showDialog = true
    },
    edit(row) {
      this.action = 'editMerchant'
      this.formData = row
      this.showDialog = true
    },

    editTieredBilling(row) {
      this.$axios
        .get('/merchant/tieredBillingGet', {
          params: {
            appId: row.appId,
          },
        })
        .then(res => {
          if (res.code == 200) {
            this.formData = res.data
            console.log(this.formData)
            this.isTieredBillingDialog = true
          } else {
            this.$notify.error({
              title: '提示',
              message: res.msg,
            })
          }
        })
    },

    editPayType(row) {
      this.action = 'editPayType'
      this.showSetPayDialog = true
      this.formData = row
    },
    addBizPersonnel(row) {
      this.isAddBizPersonnelDialog = true
    },

    checkWallet(row) {
      this.showWalletInfoDialog = true
      this.appId = row.appId
    },

    resetMerPass(row) {
      this.$confirm('确认重置密码？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$confirm('确认为该 ' + row.merchantName + ' 重置密码？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        }).then(() => {
          this.axios
            .post('/merchant/resetMerPass', {
              appId: row.appId,
            })
            .then(res => {
              this.$message({
                message: res.msg,
                type: 'success',
              })
            })
        })
      })
    },

    unbindTg(row) {
      this.$confirm('确认解绑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$confirm('确认为该 ' + row.merchantName + ' 解绑TG群?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        }).then(() => {
          this.axios
            .get('/merchant/unbindTg', {
              params: {appId: row.appId}
            })
            .then(res => {
              this.$message({
                message: res.msg,
                type: 'success',
              })
            })
        })
      })
    },

    unbindGoogle(row) {
      this.$confirm('确认重置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$confirm('确认为该 ' + row.merchantName + ' 重置谷歌验证?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        }).then(() => {
          this.axios
            .get('/merchant/unbindGoogle', {
              params: {appId: row.appId}
            })
            .then(res => {
              this.$message({
                message: res.msg,
                type: 'success',
              })
            })
        })
      })
    },

    addMerStaffUser(row) {
      // this.formData = row;
      this.$confirm(
        '确认为该 ' + row.merchantName + ' 商户添加员工号？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        }
      )
        .then(() => {
          this.axios
            .post('/merchant/addMerStaffUser', {
              appId: row.appId,
            })
            .then(res => {
              let filename
              var contentDisposition = res.headers['content-disposition']
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
              var matches = filenameRegex.exec(contentDisposition)
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '')
              }

              let blob = new Blob([res.data], {
                type: 'text/plain',
              })
              // 将blob对象转为一个URL
              var blobURL = window.URL.createObjectURL(blob)
              // 创建一个a标签
              var tempLink = document.createElement('a')
              // 隐藏a标签
              tempLink.style.display = 'none'
              // 设置a标签的href属性为blob对象转化的URL
              tempLink.href = blobURL
              // 给a标签添加下载属性
              tempLink.setAttribute('download', filename)
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
              }
              // 将a标签添加到body当中
              document.body.appendChild(tempLink)
              // 启动下载
              tempLink.click()
              // 下载完毕删除a标签
              document.body.removeChild(tempLink)
              window.URL.revokeObjectURL(blobURL)
              this.$message({
                message: '导出成功~',
                type: 'success',
              })
            })
        })
        .catch(() => {})
    },
  },

  created() {
    if (this.$store.state.roleId == '1070960390067716097') {
      this.$axios
        .get('/agent/selectAgentForOption', { params: {} })
        .then(res => {
          this.agentList = res.data
        })
    }
    if (this.$store.state.roleId == '1070960390067716097') {
      this.$axios
        .get('/bizSettlement/selectBizPersonnel', { params: {} })
        .then(res => {
          this.selectBizPersonnel = res.data
        })
    }
  },
}
</script>

<style scoped>
</style>